import { Search, Plus, Trash2, Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Select } from '@/components/ui/select';

interface Props {
	title: string;
	total: number;
	search: string;
	onSearchChange: (v: string) => void;
	statusFilter: string;
	onStatusChange: (v: string) => void;
	activeFilter: string;
	onActiveChange: (v: string) => void;
	selectedCount: number;
	onAdd: () => void;
	onBatchDelete: () => void;
	onMenuToggle: () => void;
}

export function Topbar({
	title,
	total,
	search,
	onSearchChange,
	statusFilter,
	onStatusChange,
	activeFilter,
	onActiveChange,
	selectedCount,
	onAdd,
	onBatchDelete,
	onMenuToggle,
}: Props) {
	return (
		<div className="px-4 md:px-5 py-2.5 min-h-[56px] border-b border-line bg-[#fafafa] sticky top-0 z-30 flex items-center gap-2.5 flex-wrap">
			<button onClick={onMenuToggle} className="icon-btn md:hidden" aria-label="菜单">
				<Menu size={16} />
			</button>
			<h1 className="text-[26px] font-semibold tracking-tight whitespace-nowrap">{title}</h1>
			<span className="text-[16px] text-ink-3 whitespace-nowrap hidden md:inline">· 共 <span className="tabular">{total}</span> 条</span>
			<div className="flex-1 min-w-[8px]" />

			<div className="relative flex-1 min-w-[180px] max-w-[360px] order-10 md:order-none basis-full md:basis-auto">
				<Search size={14} className="absolute left-2.5 top-2 text-ink-3 pointer-events-none" />
				<input
					value={search}
					onChange={(e) => onSearchChange(e.target.value)}
					placeholder="搜索房号、小区、装潢、学区..."
					className="w-full bg-transparent border border-transparent rounded-md pl-8 pr-2.5 py-1.5 text-[17px] text-ink hover:bg-[#f4f4f3] focus:bg-white focus:border-line-strong focus:outline-none placeholder:text-ink-3 transition-colors"
				/>
			</div>

			<Select value={statusFilter} onChange={(e) => onStatusChange(e.target.value)} className="hidden md:inline-flex">
				<option value="">全部状态</option>
				<option value="出售">出售</option>
				<option value="出租">出租</option>
				<option value="已售">已售</option>
				<option value="已租">已租</option>
			</Select>
			<Select value={activeFilter} onChange={(e) => onActiveChange(e.target.value)} className="hidden lg:inline-flex">
				<option value="">全部</option>
				<option value="true">仅有效</option>
				<option value="false">仅无效</option>
			</Select>

			{selectedCount > 0 && (
				<Button variant="danger" size="sm" onClick={onBatchDelete} className="gap-1">
					<Trash2 size={12} /> 删除 ({selectedCount})
				</Button>
			)}
			<Button variant="primary" onClick={onAdd} className="gap-1">
				<Plus size={14} /> 新增房源
			</Button>
		</div>
	);
}
